import { useEffect } from 'react';

const SITE_NAME = 'Ink & Innovation Printworks';

// React 19 hoists <title>, <meta>, and <link> to the document head.
export const Seo = ({ title, description, image, type = 'website', noindex = false, jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Bold Literary Fiction by Kavi Ocktiiv`;
  const url = typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : '';
  const defaultImage = typeof window !== 'undefined' ? `${window.location.origin}/inklogo_transparent.png` : '';

  useEffect(() => {
    document.querySelectorAll('[data-static-seo]').forEach((el) => el.remove());
  }, []);

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {(image || defaultImage) && <meta property="og:image" content={image || defaultImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {url && <link rel="canonical" href={url} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </>
  );
};

export default Seo;
